import {getRequest} from "@pg-mono/request";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IOfferDetail} from "../../offer/types/IOfferDetail";

export async function getOfferDetails(offerId: number) {
    const offerDetailApiLink = apiV2Link.offer.detail(Scenario.OFFER_DETAIL, {offerId: offerId});

    const offerDetailsRes = await getRequest(clientRpRequestMeta, offerDetailApiLink);

    return offerDetailsRes as IOfferDetail;
}
import {getRequest} from "@pg-mono/request";
import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {IOfferDetail} from "../../offer/types/IOfferDetail";

export async function getOfferDetails(offerId: number) {
    const offerDetailApiLink = apiV2Link.offer.detail(Scenario.OFFER_DETAIL, {offerId: offerId});

    const offerDetailsRes = await getRequest(clientRpRequestMeta, offerDetailApiLink);

    return offerDetailsRes as IOfferDetail;
}
